import { Circle } from "@mui/icons-material";
import { SxProps, useTheme } from "@mui/material";
import { IStatus } from "src/constants";

interface IProps {
  status: IStatus;
  faded?: boolean;
  sx?: SxProps;
  fontSize?: "inherit" | "small" | "medium" | "large";
}

const StatusIcon = (props: IProps) => {
  const theme = useTheme();
  const Icon = props.status.icon ?? Circle;

  return (
    <Icon
      sx={{
        color: props.faded ? theme.palette.grey[300] : props.status.color,
        ...props.sx,
      }}
      fontSize={props.fontSize}
    />
  );
};

export { StatusIcon };
